import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';

import { type PartnerOfferStatusCounts } from '@/api/routes/partners/partners.offers.api';
import { type OffersTab } from '@/domain/offers/types';
import { OFFERS_TABS, offersTabLabel } from '@/domain/offers/utils';

interface Props {
  value: OffersTab;
  counts?: PartnerOfferStatusCounts;
  onChange: (tab: OffersTab) => void;
}

/** One tab per status, with its count (P18). A zero shows as "0", never as a dash. */
const OffersStatusTabs = ({ value, counts, onChange }: Props) => (
  <Tabs
    value={value}
    onChange={(_, tab: OffersTab) => onChange(tab)}
    variant="scrollable"
    scrollButtons="auto"
    allowScrollButtonsMobile
  >
    {OFFERS_TABS.map((tab) => (
      <Tab
        key={tab}
        value={tab}
        label={counts ? `${offersTabLabel[tab]} (${counts[tab]})` : offersTabLabel[tab]}
      />
    ))}
  </Tabs>
);

export default OffersStatusTabs;
